import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M20 0v20L5.858 34.142A19.938 19.938 0 0 0 20 40c11.046 0 20-8.954 20-20S20 0 20 0Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#0052B4",
  d: "M20 0A19.938 19.938 0 0 0 5.858 5.858L20 20h20C40 8.954 31.046 0 20 0Z"
}, null, -1), i = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "m13.695 20-2.443-1.149 1.3-2.366-2.652.508-.336-2.68-1.847 1.971-1.848-1.97-.336 2.679-2.652-.508 1.3 2.366L1.74 20l2.443 1.149-1.3 2.365 2.652-.507.335 2.68 1.848-1.971 1.847 1.97.336-2.679 2.653.508-1.3-2.366 2.442-1.15ZM5.334 7.826l.813 1.136 1.331-.422-.83 1.125.814 1.136-1.326-.442-.83 1.124.011-1.397-1.325-.441 1.331-.422.01-1.397Zm0 20.691.813 1.136 1.331-.422-.83 1.124.814 1.136-1.326-.441-.83 1.124.011-1.397-1.325-.442 1.331-.421.01-1.397Zm11.593-10.345-.813 1.136-1.331-.422.83 1.124-.814 1.136 1.326-.442.83 1.124-.011-1.396 1.325-.442-1.331-.422-.01-1.396Z"
}, null, -1), d = [
  n,
  s,
  c,
  i
];
function h(_, r) {
  return e(), l("svg", o, [...d]);
}
const a = { render: h };
export {
  a as default,
  h as render
};
